import {publishCount, publishTime} from "../util/MetricUtility";
import {
    ERROR_METRIC_SUFFIX,
    TIMEOUT_STRING
} from "../util/Constants";

const postMessagePromises = {};

const subscribeAbleEvents = {
    "sendCoralServiceData": sendCoralServiceData,
    "sendApiGatewayResponse": sendApiGatewayResponse
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

function sendCoralServiceData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function generateGuid() {
    /**
     * @return {string}
     */
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}

export async function getCoralServiceDataFromParent(args, processName, metricName) {
    let response;
    const startTime = Date.now();
    try {
        response = await postMessagePromised(window.parent, {
            method: 'getCoralServiceDataFromParent',
            args: args
        }, '*');
    } catch (e) {
        console.error('Error ', e);
        publishCount(processName, metricName + ERROR_METRIC_SUFFIX);
        throw e;
    }
    publishTime(processName, metricName, startTime);
    return response;
}

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*', 200);
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
            }, timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}



// WEBPACK FOOTER //
// ./src/components/handler/ParentDataHandler.js